import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { CREDIT_EXPIRATION_POLICIES, type CreditExpirationPolicy } from '@vy/types';
import { type AddCreditForm } from '../add-credit-form/add-credit-form-schema';

const POLICY_OPTIONS: readonly { value: CreditExpirationPolicy; label: string }[] = [
  { value: CREDIT_EXPIRATION_POLICIES.AT_NEXT_GRANT, label: 'At next renewal' },
  { value: CREDIT_EXPIRATION_POLICIES.END_OF_INVOICE, label: 'End of invoice period' },
  { value: CREDIT_EXPIRATION_POLICIES.END_OF_RENEWAL_PERIOD, label: 'End of renewal period' },
  { value: CREDIT_EXPIRATION_POLICIES.END_OF_CONTRACT, label: 'End of contract' },
  { value: CREDIT_EXPIRATION_POLICIES.NEVER, label: 'Never expire' },
];

export const ExpirationPolicySelect: React.FC = () => {
  const { watch, setValue } = useFormContext<AddCreditForm>();
  const expirationPolicy = watch('expirationPolicy');

  return (
    <FormControl fullWidth>
      <InputLabel>Credit expiration</InputLabel>
      <Select
        label="Credit expiration"
        value={expirationPolicy ?? CREDIT_EXPIRATION_POLICIES.AT_NEXT_GRANT}
        onChange={(e) =>
          setValue('expirationPolicy', e.target.value as CreditExpirationPolicy, {
            shouldDirty: true,
            shouldValidate: true,
          })
        }
        data-vy="add-credit-drawer-expiration-policy-select"
      >
        {POLICY_OPTIONS.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
